import { computed } from 'vue'

export default {
    name: "ChatMessageCard",
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        readmoreLabel: {
            type: String,
            required: true
        },
        href: {
            type: String,
            required: true
        },
        filename: {
            type: String,
            required: false
        }
    }
}